module.exports = __webpack_public_path__ + "static/media/008.73ec5de1.jpg";